{{name}}<span class="remove-category"><i class="fa fa-times"></i></span>